import { Suspense } from 'react';
import { useParams } from 'react-router-dom';

import { ApiErrorBoundary, GiftDetailPage, GiftProductSection } from '@/shared/features';
import { useGiftDetail } from '@/shared/hooks/apis';
import { Loading } from '@/shared/ui/Loading';

type GiftDetailContentProps = {
  giftNo: number;
};

const GiftDetailContent = ({ giftNo }: GiftDetailContentProps) => {
  const { data: giftDetail } = useGiftDetail(giftNo);

  return (
    <GiftDetailPage giftDetail={giftDetail} isPc>
      <ApiErrorBoundary errorComponent={null}>
        <Suspense fallback={<Loading cssproperties={{ height: '200px' }} />}>
          <GiftProductSection giftNo={giftNo} />
        </Suspense>
      </ApiErrorBoundary>
    </GiftDetailPage>
  );
};

const GiftDetailPageContainer = () => {
  const { giftId } = useParams<{ giftId: string }>();
  const giftNo = Number(giftId) || 0;

  return (
    <Suspense fallback={<Loading cssproperties={{ height: '100vh' }} />}>
      <GiftDetailContent giftNo={giftNo} />
    </Suspense>
  );
};

export { GiftDetailPageContainer as GiftDetail };
